import React from 'react';
import { useDroppable } from '@dnd-kit/core';

export function Droppable(props) {
  const { isOver, setNodeRef } = useDroppable({
    id: props.id || 'droppable',
    data: props.data || undefined
  });

  return (
    <div ref={setNodeRef} className={isOver ? `${props.className || ""} droppable-item-active` : `${props.className || ""}`}>
      {props.children}
    </div>
  );
}